export const CLAIM_SERVICE_TYPES = {
  INSURANCE: 'insurance',
  TRANSFER: 'transfer',
  TRANSPORT: 'transport',
};
